import { type Nullable } from '../types';

const priceFormat = (currencyCode: string): Intl.NumberFormatOptions => ({
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

const formatAlgoliaPriceFilter = (
    min: Nullable<number>,
    max: Nullable<number>,
    maxBoundary: number,
): string => {
    const resolvedMin = !min || min <= 0 ? 0 : min;
    const resolvedMax = !max || max >= maxBoundary ? `${maxBoundary}+` : max;

    return `price:${resolvedMin}-${resolvedMax}`;
};

const formatTrackingPriceRange = ({
    currencyCode,
    locale,
    max,
    min,
}: {
    currencyCode: string;
    locale: string;
    max: Nullable<number>;
    min: Nullable<number>;
}) => {
    if (!min && !max) {
        return 'not selected';
    }

    const minPrice = min
        ? new Intl.NumberFormat(locale, priceFormat(currencyCode)).format(min)
        : 'not selected';

    const maxPrice = max
        ? new Intl.NumberFormat(locale, priceFormat(currencyCode)).format(max)
        : 'not selected';

    return `${minPrice} - ${maxPrice}`;
};

export { formatAlgoliaPriceFilter, formatTrackingPriceRange };
